// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as NextImage$PorterinFeature from "../../../../../../ui/components/NextImage.mjs";
import * as SpotEstimateVm$PorterinFeature from "../../../../../../shared/spot-lead-flow/view/view-model/SpotEstimateVm.mjs";
import * as ChangeLocationActionCmp$PorterinFeature from "./ChangeLocationActionCmp.mjs";
import * as ConfirmLocationActionCmp$PorterinFeature from "./ConfirmLocationActionCmp.mjs";
import * as LocationInfoActionCmpModuleScss from "../styles/LocationInfoActionCmp.module.scss";

var styles = LocationInfoActionCmpModuleScss;

function LocationInfoActionCmp(Props) {
  var waypoint = Props.waypoint;
  var on_click = Props.on_click;
  var open_select_location = Props.open_select_location;
  var location_address = Props.location_address;
  var icon = waypoint ? SpotEstimateVm$PorterinFeature.input_to_icon : SpotEstimateVm$PorterinFeature.input_from_icon;
  return React.createElement("div", {
              className: styles.container
            }, React.createElement("div", {
                  className: styles["address-wrapper"]
                }, React.createElement(NextImage$PorterinFeature.make, {
                      src: icon.src,
                      height: icon.height,
                      width: icon.width,
                      alt: icon.alt,
                      className: styles.icon,
                      key: icon.alt
                    }), React.createElement(ChangeLocationActionCmp$PorterinFeature.make, {
                      open_select_location: open_select_location,
                      city: location_address.postalAddress.city
                    }), React.createElement(ConfirmLocationActionCmp$PorterinFeature.make, {
                      landmark: location_address.address.landmark,
                      on_confirm: on_click,
                      waypoint: waypoint
                    })));
}

var make = LocationInfoActionCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
